import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUser, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { ClienteService } from '../services/supabase';
import { Cliente } from '../types';
import { ClientListModal } from './ClientListModal';

interface SearchFormProps {
  onClienteEncontrado: (cliente: Cliente) => void;
  onError: (message: string) => void;
}

export const SearchForm: React.FC<SearchFormProps> = ({ onClienteEncontrado, onError }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showClientModal, setShowClientModal] = useState(false);
  const [foundClients, setFoundClients] = useState<Cliente[]>([]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email.trim()) {
      onError('Por favor, digite o email do cliente');
      return;
    }

    setIsLoading(true);
    
    try {
      const { data, error } = await ClienteService.buscarPorEmail(email.trim());
      
      if (error) {
        onError(error.message || 'Erro ao buscar cliente');
        return;
      }

      if (data && data.length > 0) {
        if (data.length === 1) {
          // Se encontrou apenas um cliente, seleciona automaticamente
          onClienteEncontrado(data[0]);
        } else {
          // Se encontrou múltiplos clientes, mostra modal
          setFoundClients(data);
          setShowClientModal(true);
        }
      } else {
        onError('Cliente não encontrado');
      }
    } catch (error) {
      onError('Erro de conexão. Verifique sua internet e tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };


  const handleClientSelect = (client: Cliente) => {
    onClienteEncontrado(client);
    setShowClientModal(false);
    setFoundClients([]);
  };

  return (
    <div className="card search-form">
      <div className="card-header">
        <FontAwesomeIcon icon={faUser} className="card-icon" size="lg" />
        <h2>Buscar Cliente</h2>
      </div>
      
      <form onSubmit={handleSubmit} className="form">
        <div className="form-group">
          <label htmlFor="emailCliente">Email do cliente:</label>
          <div className="input-group">
            <input
              type="email"
              id="emailCliente"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Digite o email do cliente"
              disabled={isLoading}
              className="form-input"
            />
            <button 
              type="submit" 
              disabled={isLoading || !email.trim()}
              className="btn btn-primary"
            >
              {isLoading ? (
                <FontAwesomeIcon icon={faSpinner} className="spinner" spin />
              ) : (
                <FontAwesomeIcon icon={faSearch} />
              )}
              {isLoading ? 'Buscando...' : 'Buscar'}
            </button>
          </div>
        </div>
        
      </form>
      
      {/* Modal de Lista de Clientes */}
      <ClientListModal
        isOpen={showClientModal}
        onClose={() => setShowClientModal(false)}
        clients={foundClients}
        onSelectClient={handleClientSelect}
      />
    </div>
  );
};
